import React, { forwardRef } from 'react';
import cn from 'classnames';
import Title from 'components/UI/Title';
import { useTrans } from 'utils/localisation';
import * as styles from './Step.module.scss';

function Step({ className, onClose, title, block, currentStep, lastStep, ...rest }, ref) {
  const t = useTrans(['pricingCalculator']);
  const Component = require(`../../blocks/${block}`).default;

  return (
    <div className={cn(styles.stepWrapper, className)} ref={ref}>
      <div className={styles.text}>{`${t('step')} ${currentStep} ${t('of')} ${lastStep}`}</div>
      <Title tag="h4" className={styles.title}>
        {title}
      </Title>
      <div className={styles.scrollArea}>
        <Component {...rest} />
      </div>
    </div>
  );
}

export default forwardRef(Step);
